import { render } from "./BaseSlider.vue?vue&type=template&id=6c835a7e&scoped=true"
import script from "./BaseSlider.vue?vue&type=script&lang=js"
export * from "./BaseSlider.vue?vue&type=script&lang=js"

import "./BaseSlider.vue?vue&type=style&index=0&id=6c835a7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c835a7e"

export default script